import {isPartOfBaseURL} from 'shared/utils/url-utils';
import type {Link} from 'typings/portaro.fe.types';

export function resolveTarget(link: Link): '_self' | '_blank' {
    if (isPartOfBaseURL(link.url)) {
        return '_self';
    }
    return '_blank';
}

export function resolveHref(link: Link): string {
    return link.url;
}